module.exports = __webpack_public_path__ + "media/03_final.0d985704.mp4";